<div class="flex flex-row justify-center items-center gap-3 p-2 login-buttons">
  <button
    id="btn_login_options_open_signup"
    bv-button variant="primary"
    (click)="openSignup()"
    class="mat-button-lg"
  >
    {{ "SIGNUP" | translate }}
  </button>
  <button
    id="btn_login_options_open_login"
    bv-button variant="primary"
    (click)="openLogin()"
    class="mat-button-lg bv-button-info"
  >
    {{ "LOGIN" | translate }}
  </button>
</div>
